import React from 'react';
import _ from 'lodash';

import './NumberLine.scss';
import BallsContainer from 'src/components/Betslip/NumberBet/Components/BallsContainer/BallsContainer';
import formatOdds from 'src/utils/formatOdds';
import { useSelector } from 'react-redux';
import { RootState } from 'src/configs/store';

interface NumberLineProps {
  numbers: number[],
  stake: number,
  odds: number,
  profit: number,
  selectedNumbers: any,
  sameDrum: boolean,
  isHorses: boolean
}

function NumberLine({ numbers, stake, odds, profit, selectedNumbers, sameDrum, isHorses }: NumberLineProps) {
  const selectedOddsType = useSelector((state: RootState) => state.odds.selectedOddsType);

  const getSelectedNumbers = () => {
    const permutationArray = [];

    for (const number of numbers){
      const selectedNumber = _.find(selectedNumbers, { number: +number });
      permutationArray.push(selectedNumber);
    }
    return _.compact(permutationArray);
  };

  return (
    <div className="number-line">
      <div className="number-line__container">
        <div className="number-line__balls-container">
          { !isHorses && <BallsContainer anyNumbers={ getSelectedNumbers() } sameBallset={ sameDrum } big /> }
          {
            isHorses &&
              numbers.join(',')
          }
        </div>
        <span>{ +stake > 0 ? stake.toFixed(2) : '-' }</span>
        <span>{ odds == +odds ? formatOdds(odds, selectedOddsType) : 'TP' }</span>
        <span>{ profit ? (profit)?.toFixed(2) : '-' }</span>
      </div>
    </div>
  );
}

export default NumberLine;
